import { doFetch, setServiceCredentials, clearServiceCredentials } from "./service";

const SystemResource = {};

const serviceUrl = '/dict-service-rest-portal/webresources/system';

function usernamePasswdAuthHeaders(username, password) {
    return {
        'Authorization': 'Basic ' + btoa(username + ':' + password)
    };
}


SystemResource.auth = (email, password) => {
    return doFetch(serviceUrl + '/auth',
        {
            method : 'GET',
            headers : usernamePasswdAuthHeaders(email, password)
        },
        null
    ).then(
        () => {
            setServiceCredentials(email, password);
            return Promise.resolve();
        },
        () => {
            clearServiceCredentials();
            return Promise.reject('Authentication failed');
        }
    );
};

SystemResource.stats = () => {
    return doFetch(serviceUrl + '/stats',
        {
            method : 'GET',
        },
        null
    ).then(
        (response) => {
            return Promise.resolve(response);
        },
        (response) => {
            return Promise.reject('Authentication failed');
        }
    );
};

export default SystemResource;




// WEBPACK FOOTER //
// ./src/service/SystemResource.js